<page-grid [gridConfig]="travelTypeGrid"/>
